import React, { useEffect, useState } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    TableContainer,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Text,

} from '@chakra-ui/react'
import TableRow from './TableRow';
import { ConfirmPickUp, SingleTicketNumber } from '../Utils/ApiCalls';
import ReturnToSupervisor from './ReturnToSupervisor';
import UpdatePickUpQty from './UpdatePickUpQty';


export default function PickUpModal({ isOpen, onCloseX, singleData = [], setPreLoader }) {

    console.log("singleData", singleData)

    
    const [SingleData, setSingleData] = useState(false);
    const [OpenModal, setOpenModal] = useState(false);

const [Loading, setLoading] = useState(false);
const [Msg, setMsg] = useState({
    status: false,
    msg: ""
});

    const PickUpBtn = async (id)=>{
        
        setLoading(true)
        try {
          
            let result = await ConfirmPickUp(id);
            if(result.status === true){
                setLoading(false)
                setMsg({
                    status: true,
                    msg: "Confirmed and Collected successfully",
                    color: "green"
                })
              
                setTimeout(() => {
                    setMsg({
                        status: false,
                        
                    })

                    onCloseX()
                  
                }, 3000);
            }else{
                setLoading(false)
                setMsg({
                    status: true,
                    msg: result.msg,
                    color: "red"
                })
              
                setTimeout(() => {
                    setMsg({
                        status: false,
                        
                    })

                    onCloseX()
                  
                }, 3000);
              
               
            }
            console.log("result", result);
           
            
        } catch (e) {
  
            
        }
    }

    const [Data, setData] = useState([]);

    const [Open, setOpen] = useState(false);
    const [Id, setId] = useState(false);

    const returnToSupervisor = (id)=>{
        setOpen(true) 
        setId(id)
    }

    const editQty = (id) => {

        let singleInfo = singleData.filter((item, i) => {
            return item._id === id
        })
       
        setOpenModal(true)
        setSingleData(singleInfo)
       
    }



    
    useEffect(() => {
      
       
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onCloseX} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>PickUp Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
{
    Loading ? (
        <Text textAlign={"center"}>Please wait...</Text>
    ):(
        Msg.status && (
            <Text textAlign={"center"} color={Msg.color}>{Msg.msg}</Text>
        )
    )
}
              
                    <TableContainer mt="32px" mb="64px" overflowX="auto" color="#fff"

                    >
                        <Table variant='simple' size='sm'>
                            <Thead>
                                <Tr>
                                    <Th >S/N</Th>
                                    <Th >Name</Th>
                                    <Th >Quantity Requested</Th>
                                    <Th >Quantity Left</Th>
                                    <Th >zone</Th>
                                    <Th >location</Th>
                                    <Th >district</Th>
                                    <Th >feeder</Th>
                                    <Th >Status</Th>
                                    <Th >Action</Th>


                                </Tr>
                            </Thead>
                            <Tbody>

                            {
                                singleData && (
                                    singleData?.map((item, i) => (
                                        <TableRow
                                            type={"pickUpGroupModal"}
                                            key={i}
                                            color="#000"
                                            sn={i + 1}
                                            qtyLeft={item.productkey?.qty}
                                            productName={item?.productname}
                                            status={item?.status}
                                            zone={item?.zone}
                                            location={item?.location}
                                            district={item?.district}
                                            feeder={item?.feeder}
                                            qty={item?.qtyrequested}
                                            onEdit={() => editQty(item._id)}
                                            returnTo={()=>returnToSupervisor(item?._id)}
                                            onClick={() => PickUpBtn(item?._id)}

                                        />
                                    ))
                                )
                                    
                                }
                            </Tbody>

                        </Table>
                    </TableContainer>
                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
            <ReturnToSupervisor isOpen={Open} onClose={()=>setOpen(false)} id={Id}  />

            <UpdatePickUpQty SingleData={SingleData} state="pickUpGroupModal" isOpen={OpenModal} onClose={() => {
                setOpenModal(false)
                onCloseX()
            }}  />

        </Modal>
    )
}
